import i18n from '@i18next/i18n';

class PageExitManager {
    private static instance?: PageExitManager;

    public static getInstance() {
        if (!this.instance) {
            this.instance = new PageExitManager();
        }

        return this.instance;
    }

    private totalPendingTask = 0;

    private constructor() {
        if (typeof window !== 'undefined') {
            window.addEventListener('beforeunload', (event) => {
                if (this.isDirty) {
                    event.preventDefault();
                    event.returnValue = true;
                    return i18n.t('有未保存的修改，确认退出');
                }
            });
        }
    }

    private get isDirty() {
        return this.totalPendingTask > 0;
    }

    public protect = () => {
        this.totalPendingTask += 1;
    };

    public release = () => {
        this.totalPendingTask = Math.max(0, this.totalPendingTask - 1);
    };
}

export default PageExitManager;
